import { VipLevelConfig } from '@gains-com/shared';
import { environment } from '../../../environments/environment';

/**
 * Per-tier and shared VIP art is interpolated from the CDN at runtime rather
 * than stored as a URL per asset. This keeps art per-environment in sync —
 * staging serves staging art — and lets a single `vip_tier_key` drive a whole
 * folder of tier assets. Paths follow
 * `${cdnUrl}/images/vip/[<tier_key>/]<asset>.webp`.
 */

/** Per-tier asset URL: `${cdnUrl}/images/vip/<tier_key>/<asset>` (e.g. crown.webp). */
export function vipTierAsset(config: Pick<VipLevelConfig, 'vip_tier_key'>, asset: string): string {
  return `${environment.cdnUrl}/images/vip/${config.vip_tier_key}/${asset}`;
}

/** Shared (tier-agnostic) asset URL: `${cdnUrl}/images/vip/<asset>` (e.g. background.webp). */
export function vipSharedAsset(asset: string): string {
  return `${environment.cdnUrl}/images/vip/${asset}`;
}

/**
 * Tier badge URL. When `vip_tier_key` is set the per-tier `logo.webp` wins;
 * otherwise fall back to the config's stored `logo_url`.
 */
export function vipBadgeUrl(config: Pick<VipLevelConfig, 'vip_tier_key' | 'logo_url'>): string | null {
  return config.vip_tier_key ? vipTierAsset(config, 'logo.webp') : (config.logo_url ?? null);
}
